import YearRoundScenarioView from '@/components/YearRoundScenarioView';
import { getStrategy } from '@/lib/yearRoundStrategies';

export default function StrategySummerFullMixPage() {
  const s = getStrategy('summer_full_mix');
  if (!s) return null;
  return <YearRoundScenarioView strategy={s} />;
}
